import { useSelector } from "react-redux";
import { AssemblyCalendar } from "../modules/AssemblyCalendar/AssemblyCalendar";
import { AuthenticationState } from "../interfaces/users";
import { hasNoPermission } from "../utils/helpers/userHelpers";
import { useMemo } from "react";
import { TableSearchProvider } from "../modules/AssemblyCalendar/SuggestSchedule/searchContext";

function AssemblyCalendarPage() {
  const { user } = useSelector((state: AuthenticationState) => state);
  const hasPermission = useMemo(
    () => hasNoPermission("assemble", user),
    [user]
  );
  return (
    <>
      {hasPermission ? (
        <TableSearchProvider>
          <AssemblyCalendar />
        </TableSearchProvider>
      ) : (
        <div>O seu usuário não possui permissão para acessar este conteúdo</div>
      )}
    </>
  );
}

export default AssemblyCalendarPage;
